import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 24px 0px;
  width: 100%;
  box-sizing: border-box;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const Title = styled.div`
  color: var(--Foreground-Neutral-faded, #4d5874);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`
